import { tracking as barkTrackingLogEvent } from '@bark/bark-core';
import moment from 'moment';

export const trackCallNow = async (projectId, sellers, pageNum, pageSize, buyer_id) => {
	await new Promise((resolve, reject) => {
		// pagesize is always 10, if it changes then can be passed as a parameter instead
		if (!pageSize) {
			pageSize = 10;
		}
		if (projectId && sellers.length) {
			let callBackSellers = [];
			sellers.map((seller, index) => {
				const orderPosition = (pageNum - 1) * pageSize + index + 1;
				if (seller?.attributes?.match_types.includes('booking')) {
					callBackSellers.push({
						seller_id: seller.id,
						list_order: orderPosition,
					});
				}
			});
			if (callBackSellers.length) {
				barkTrackingLogEvent('seller-list-&-profile', 'Callbacks - Active', {
					project_id: projectId,
					seller_profile_ids: callBackSellers
						.map((enquirySeller) => enquirySeller['seller_id'])
						.join(),
					'Number on list': callBackSellers
						.map((enquirySeller) => enquirySeller['list_order'])
						.join(),
					page_number: pageNum,
					buyer_id,
				});
			}
		}
		resolve();
	});

	trackMarketplaceBookings(projectId, sellers, pageNum, pageSize, buyer_id);
};

export const trackMarketplaceBookings = async (
	projectId,
	sellers,
	pageNum,
	pageSize,
	buyer_id,
) => {
	await new Promise((resolve, reject) => {
		// pagesize is always 10, if it changes then can be passed as a parameter instead
		if (!pageSize) {
			pageSize = 10;
		}
		if (projectId && sellers.length) {
			let enquirySellers = [];
			sellers.map((seller, index) => {
				const orderPosition = (pageNum - 1) * pageSize + index + 1;
				if (seller?.attributes?.match_types.includes('marketplace-booking')) {
					enquirySellers.push({
						seller_id: seller.id,
						list_order: orderPosition,
					});
				}
			});
			if (enquirySellers.length) {
				if (window.hj) {
					window.hj('event', 'marketplace_booking_available');
				}
				var date = moment.utc().format('YYYY-MM-DD HH:mm:ss');
				var stillUtc = moment.utc(date).toDate();

				barkTrackingLogEvent('seller-list-&-profile', 'Marketplace Booking - Active', {
					project_id: projectId,
					seller_profile_ids: enquirySellers
						.map((enquirySeller) => enquirySeller['seller_id'])
						.join(),
					list_orders: enquirySellers
						.map((enquirySeller) => enquirySeller['list_order'])
						.join(),
					page_number: pageNum,
					'buyer time': date,
					'utc time': moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss'),
					buyer_id,
				});
			}
		}
		resolve();
	});
};
